<script>
import {defineComponent} from "vue";
import * as bootstrap from "bootstrap/dist/js/bootstrap.esm";

export default defineComponent({
  setup() {
    const open = (modal) => {
      const instance = new bootstrap.Modal(modal);
      instance.show();
    }

    return {
      open,
    }
  }
})
</script>

<template>
  <slot name="modal"></slot>
  <slot name="action" :open="open" />
</template>
